export const enum WidgetPlatform {
    Android = 'ANDROID',
    IOS = 'IOS',
    Web = 'WEB',
}
